import { Platform } from './types';

/** Detect runtime target. Order: Discord (`.discordsays.com`/`frame_id`) → Tauri → Capacitor → Web. */
export const detectPlatform = (): Platform => {
  if (typeof window === 'undefined') return Platform.Web;

  const url = new URL(window.location.href);
  if (url.hostname.endsWith('.discordsays.com') || url.searchParams.has('frame_id')) {
    return Platform.Discord;
  }

  if ('__TAURI_INTERNALS__' in window || '__TAURI__' in window) {
    return Platform.Tauri;
  }

  const cap = (window as unknown as { Capacitor?: { isNativePlatform?: () => boolean } }).Capacitor;
  if (cap && typeof cap.isNativePlatform === 'function' && cap.isNativePlatform()) {
    return Platform.Capacitor;
  }

  return Platform.Web;
};
